import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable()
export class ToastNotifierService {
  constructor(private messageService: MessageService) { }

  public fail(message: string, sticky: boolean) {
    this.messageService.add({ key: 'bc', severity: 'error', summary: 'Mensaje de error', detail: message, sticky: sticky });
  }

  public success(message: string) {
    this.messageService.add({ key: 'bc', severity: 'success', summary: 'Mensaje de éxito', detail: message });
  }

  public warning(message: string) {
    this.messageService.add({ key: 'bc', severity: 'warn', summary: 'Mensaje de advertencia', detail: message });
  }
}
